<template>
  <ion-page v-touch:swipe.right="onSwipeRight" v-touch:swipe.left="onSwipeLeft">
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-title>Trackman</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-header class="paddingtop"  :translucent="true">
      <ion-list>
        <ion-item v-if="selectedTrackman && selectedTrackman.selectedItem" lines="full" class="itemFlight">
          <ion-button fill="clear" slot="start" @click="openTrackmanHelp()" >
            <ion-icon :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'" color="primary" :md="helpCircleOutline" :ios="helpCircleOutline"></ion-icon>
          </ion-button>
          <ion-button fill="clear" slot="start" @click="refresh()" >
            <ion-icon :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'" color="primary" :md="refreshOutline" :ios="refreshOutline"></ion-icon>
          </ion-button>
          <ion-select interface="action-sheet" slot="end" v-model="selectedSelection" @ionChange="itemChanged($event.target.value)">
            <ion-select-option v-for="(item, index) in selectedTrackman.selection" :key="index" :value="item">{{ item.name }}</ion-select-option>          
          </ion-select>
        </ion-item>
        <ion-item lines="full" v-if="selectedTrackman">
          <ion-button :title="$t('today')" fill="clear" slot="start" @click="goDateToday()" >
            <ion-icon color="primary" :md="todayOutline" :ios="todayOutline" :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'"></ion-icon>
          </ion-button>
          <ion-button fill="clear" slot="start" @click="goDateBack()" >
            <ion-icon :md="arrowBackOutline" :ios="arrowBackOutline" :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'"></ion-icon>
          </ion-button>
          <ion-datetime
            :min="`${(new Date()).getFullYear()-1}-01-01`"
            :max="`${(new Date()).getFullYear()+1}-12-31`"
            slot="start"
            :value="selectedDate"
            @ionChange="
              ev => {
                const raw = ev.detail.value;
                if (!raw) return;
                const picked = dayjs(raw).format('YYYY-MM-DD');  // kein .tz() → kein Drift
                if (picked !== $route.params.date) {
                  forceSpinner = true;
                  $router.push('/trackman/' + selectedTrackman.selectedItem.id + '/' + picked);
                  selectedDate = picked;
                }
              }
            "
            :day-short-names="customDayShortNames"
            display-format="DDD, DD MMM YY"
            placeholder="Select Date">
          </ion-datetime>

          <ion-button fill="clear" slot="start" @click="goDateForward()" >
            <ion-icon @click="goDateForward()" :md="arrowForwardOutline" :ios="arrowForwardOutline" :style="isPlatform('mobile') ? 'zoom: 1.0' : 'zoom: 1.2'"></ion-icon>
          </ion-button>
        </ion-item>
      </ion-list>

    </ion-header>


    <ion-content :fullscreen="true" ref="content">
      <ion-refresher v-if="isPlatform('mobile')" slot="fixed" @ionRefresh="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      <ion-grid v-if="selectedTrackman && selectedDate" style="z-index: 999; !important" >
        <ion-row class="ion-align-items-stretch">
          <ion-col v-for="(slot, index) in selectedTrackman.slots" :key="index" size="4" size-lg="4" size-sm="6" size-xs="12">
            <ion-card :id='setId(slot)' :ref='setId(slot)'>
              <ion-card-header>
                <ion-item lines="full">
                  <ion-card-title slot="start">{{ dayjs(slot.date).tz().format('HH:mm') }}</ion-card-title>
                  <ion-card-title  v-if="!slot.isPast && (selectedTrackman.paymentEnabled || selectedTrackman.showPrice)" slot="end">{{ slot.price }} </ion-card-title>
                </ion-item>
                  <ion-list style="padding:0;" v-if="isLoggedIn && !slot.isPast && slot.canBook">
                    <ion-item v-if="slot.isFree" lines="full" class="itemFlight">
                      <ion-select value="me" interface="popover" >
                        <ion-select-option value="me">{{ $t('@me') }}
                        </ion-select-option>
                      </ion-select>
                      <ion-button v-if="((selectedTrackman && !selectedTrackman.paymentEnabled) || slot.priceFloat == 0)" fill="clear" @click="doBooking(slot)" >
                        <ion-icon style="zoom: 1.4; vertical-align: middle;" color="success" :md="downloadOutline" :ios="downloadOutline"></ion-icon>
                      </ion-button>
                      <ion-button fill="clear" @click="editBooking(slot)" >
                        <ion-icon style="zoom: 1.4; vertical-align: middle;" color="primary" :md="colorWandOutline" :ios="colorWandOutline"></ion-icon>
                      </ion-button>
                    </ion-item>
                    <ion-item v-if="slot.isMe" lines="full" color="success">
                      <ion-label class="ion-text-wrap">{{ UserData.lastName }} {{ UserData.firstName }} </ion-label>
                      <ion-icon @click="deleteBooking(slot)" v-if="slot.canDelete && !slot.isPast && isLoggedIn" :md="trashOutline" :ios="trashOutline" color="danger" style="zoom: 0.8"></ion-icon>
                    </ion-item>
                  </ion-list>
                <ion-item lines="full">
                  <ion-progress-bar v-if="slot.isPast" :value="0"></ion-progress-bar>
                  <ion-progress-bar v-else-if="slot.isFree" color="success" value="100"></ion-progress-bar>
                  <ion-progress-bar v-else color="danger" value="100"></ion-progress-bar>
                </ion-item>
              </ion-card-header>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>

    </ion-content>
  </ion-page>
</template>


<script>
import { IonLabel, IonButton, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, modalController, toastController, IonCard, 
        IonCardHeader, IonItem, IonIcon, IonRefresher, IonGrid, IonRow, IonCol, isPlatform, IonRefresherContent, IonCardTitle,
        IonSelect, IonSelectOption, IonDatetime, IonList, IonInput, loadingController, IonProgressBar, alertController } from '@ionic/vue';
import { defineComponent, ref, watch, computed } from 'vue';
import { personOutline, todayOutline, arrowBackOutline, arrowForwardOutline, helpCircleOutline, refreshOutline, downloadOutline,
        openOutline, trashOutline, colorWandOutline } from 'ionicons/icons';
import * as dayjs from 'dayjs';
require('dayjs/locale/de')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.tz.setDefault('Europe/Paris')
dayjs.locale('de')
import { useQuery,  useMutation } from '@vue/apollo-composable'
import getTrackmanQueryFile from '../graphql/getTrackman.query.gql'
import { useRoute, useRouter } from 'vue-router';
import translate from '@/plugins/translate';
import saveTrackmanBookingMutationFile from '../graphql/saveTrackmanBooking.mutation.gql'
import deleteTrackmanBookingMutationFile from '../graphql/deleteTrackmanBooking.mutation.gql'
import EditTrackmanBookingDialog from './dialogs/EditTrackmanBookingDialog'
import HelpTrackmanDialog from './HelpTrackmanDialog'

export default defineComponent({
  name: 'Trackmans',
  components: {
    IonContent, IonRefresher, IonList, IonProgressBar,
    IonHeader, IonGrid, IonRow, IonCol,
    IonPage, IonRefresherContent,
    IonTitle, IonCardTitle, IonInput,
    IonToolbar, IonSelect, IonSelectOption, IonDatetime,
    IonButton, IonLabel, IonCard, IonCardHeader, IonItem, IonIcon
  },
  setup() {
    let forceSpinner = ref(false)
    let dataLoaded = ref(false)
    let loadingSpinner = null
    const content = ref(null)
    const route = useRoute()
    const router = useRouter()
    let selectedDate = ref(dayjs.tz(new Date()).format('YYYY-MM-DD'))
    if (route.params.date)
      selectedDate = ref(dayjs.tz(new Date(route.params.date)).format('YYYY-MM-DD'))
    const customDayShortNames = [
      translate('sunday'),
      translate('monday'),
      translate('tuesday'),
      translate('wednesday'),
      translate('thursday'),
      translate('friday'),
      translate('saturday')
    ];
    const currentSlot = ref();

    const { refetch: getTrackmanRefetch, result: getTrackmanResult, loading: getTrackmanLoading } = useQuery(getTrackmanQueryFile, () => ({ id: route.path.startsWith('/trackman/') ? parseInt(route.params.id) : 0, date: dayjs(selectedDate.value).format('YYYY-MM-DD')  }), () => ({ fetchPolicy: 'no-cache', pollInterval: 60000, enabled: route.params.id != null && route.path.startsWith('/trackman/') }))
    
    // TODO: delete – useResult deprecated
    // const selectedTrackman = useResult(getTrackmanResult, null, data => data.getTrackman.calendar)
    const selectedTrackman = computed(() => getTrackmanResult.value?.getTrackman?.calendar ?? null)

    
    // TODO: delete – useResult deprecated
    // const selectedSelection = useResult(getTrackmanResult, null , data => data.getTrackman.calendar.selection.find(f => f.id == route.params.id))
    const selectedSelection = computed(() =>
      getTrackmanResult.value?.getTrackman?.calendar?.selection?.find(f => f.id == route.params.id) ?? null
    )


    watch(
      () => route.params.date,
      (date, prevId) => {
        if (route.path.startsWith('/trackman/') && date != undefined)
          selectedDate.value = dayjs.tz(new Date(route.params.date)).format('YYYY-MM-DD')
          forceSpinner.value = true
      }
    )

    loadingController.create().then(res => {
      loadingSpinner = res
      loadingSpinner.present().then(async ()  => { 
        if (!getTrackmanLoading.value && loadingSpinner != null) {
          loadingSpinner.dismiss() 
          loadingSpinner = null
          if (!dataLoaded.value)
            setTimeout(() => { var currentSlot = document.getElementById('currentSlot'); if (currentSlot) content.value.$el.scrollToPoint(0, currentSlot.parentElement.offsetTop - currentSlot.offsetTop - currentSlot.parentElement.parentElement.offsetTop - currentSlot.parentElement.parentElement.parentElement.offsetTop) }, 1000)
          dataLoaded.value = true
          forceSpinner.value = false
        }
      })
    }).catch(err => { })
    watch(getTrackmanLoading, async (newLoading, prevLoading)=> {
      if (!newLoading && loadingSpinner != null) {
          loadingSpinner.dismiss()
          loadingSpinner = null
          if (!dataLoaded.value)
            setTimeout(() => { var currentSlot = document.getElementById('currentSlot'); if (currentSlot) content.value.$el.scrollToPoint(0, currentSlot.parentElement.offsetTop - currentSlot.offsetTop - currentSlot.parentElement.parentElement.offsetTop - currentSlot.parentElement.parentElement.parentElement.offsetTop) }, 1000)
          dataLoaded.value = true
          forceSpinner.value = false
          return
      }
      else if (newLoading && (!dataLoaded.value || forceSpinner.value)) {
        loadingController.create().then(res => {
              loadingSpinner = res
              loadingSpinner.present().then(async () => { 
                if (!getTrackmanLoading.value && loadingSpinner) {
                  loadingSpinner.dismiss() 
                  loadingSpinner = null
                  if (!dataLoaded.value)
                    setTimeout(() => { var currentSlot = document.getElementById('currentSlot'); if (currentSlot) content.value.$el.scrollToPoint(0, currentSlot.parentElement.offsetTop - currentSlot.offsetTop - currentSlot.parentElement.parentElement.offsetTop - currentSlot.parentElement.parentElement.parentElement.offsetTop) }, 1000)
                  dataLoaded.value = true
                  forceSpinner.value = false
                }
              })
            }).catch(err => { })
      }
    })

    const { mutate: saveTrackmanBookingMutation } = useMutation(saveTrackmanBookingMutationFile, { fetchPolicy: 'no-cache' });
    const { mutate: deleteTrackmanBookingMutation } = useMutation(deleteTrackmanBookingMutationFile, { fetchPolicy: 'no-cache' });
   

    
    return {
      selectedTrackman, personOutline, isPlatform, selectedDate, todayOutline, arrowBackOutline, arrowForwardOutline,
      helpCircleOutline, refreshOutline, customDayShortNames, getTrackmanRefetch, getTrackmanLoading, forceSpinner, loadingSpinner, content,
      dayjs, openOutline, trashOutline, saveTrackmanBookingMutation, deleteTrackmanBookingMutation, currentSlot, downloadOutline, dataLoaded, colorWandOutline, selectedSelection
    }
  },
  computed: {
      isSuccessfullBraintreePaypalAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreePaypalAuthorized},
      isSuccessfullBraintreeCreditCardAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreeCreditCardAuthorized },
      isLoggedIn : function() { 
        if (this.isLoggedIn != undefined && this.isLoggedIn != this.$store.getters.isLoggedIn) {
          this.forceSpinner = true
          this.getTrackmanRefetch()
        }
        return this.$store.getters.isLoggedIn
      },
      UserData : function(){ return this.$store.getters.UserData}
  },
  methods: {
    onSwipeRight() {
      this.goDateBack()
	  },
    onSwipeLeft() {
      this.goDateForward()
	  },
    async doRefresh(event) {
      event.target.complete();
      await this.getTrackmanRefetch()
    },
    itemChanged(value) {
      if (value != undefined && value.id != this.selectedSelection.id) {
        this.forceSpinner = true
        this.dataLoaded = false
        this.$router.push('/trackman/' + value.id + '/' + dayjs.tz(this.selectedDate).format('YYYY-MM-DD'))
      }
      //console.log(value)
    },
    async openTrackmanHelp() {
      const modal = await modalController
        .create({
          component: HelpTrackmanDialog,
          componentProps: {
            propsData: {
              selectedTrackman: this.selectedTrackman,
            }
          },
        })
      return modal.present();
    },
    async editBooking(slot) {
      const modal = await modalController
        .create({
          component: EditTrackmanBookingDialog,
          componentProps: {
            propsData: {
              slot: slot,
              selectedTrackman: this.selectedTrackman,
            }
          },
        })
      modal.onDidDismiss()
        .then((data) => {
          if (data.data) {
            this.forceSpinner = false
            this.getTrackmanRefetch()
          }
        })

      return modal.present();
    },
    async deleteBooking(slot) {
      const alert = await alertController
        .create({
          header: 'Trackman',
          message: this.$t('delete') + ': ' + dayjs(slot.date).tz().format('DD.MM.YYYY HH:mm') + '?',
          inputs: [
            {
              name: 'comment',
              type: 'textarea',
              placeholder: this.$t('reason') || 'Reason for cancellation...'
            }
          ],
          buttons: [
            {
              text: this.$t('cancel') ,
              role: 'cancel',
              cssClass: 'secondary',
            },
            {
            text: this.$t('ok'),
            handler: async (data) => {
              const comment = data.comment?.trim();

              if (!comment) {
                toastController.create({
                  message: this.$t('commentRequired') || 'Please provide a reason before deleting.',
                  duration: 2000,
                  color: 'danger'
                }).then(t => t.present());
                return false; 
              }

              this.deleteTrackmanBookingMutation({
                date: slot.date,
                trackmanId: this.selectedTrackman.selectedItem.id,
                id: parseInt(slot.bookingId),
                interval: 1, 
                language: this.$store.getters.language,
                comment: comment
              })
              .then(res => {
                toastController.create({
                  message: this.$t('deleteSuccessful'),
                  duration: 2000,
                  color: 'warning'
                }).then(res => res.present());
                this.getTrackmanRefetch();
              })
              .catch(err => {
                toastController.create({
                  message: this.$t('deleteNotSuccessful') + ': ' + err,
                  duration: 2000,
                  color: 'danger'
                }).then(res => res.present());
              });
            }
          }
          ],
        });
      return alert.present();
    },
    async doBooking(slot) {
      if (this.selectedTrackman.paymentEnabled && slot.priceFloat > 0) {
        this.editBooking(slot)
        return
      }
      this.saveTrackmanBookingMutation({ date: slot.date, trackmanId: this.selectedTrackman.selectedItem.id, interval: 1, price: 0, language: this.$store.getters.language })
      .then(res => {
          this.forceSpinner = false
          this.getTrackmanRefetch()
          toastController
            .create({
              message: this.$t('bookingAdded'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
      })
      .catch(err => {
          toastController
            .create({
              message: this.$t('notSuccessful') + ': ' + err,
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
      }) 

    },
    setId(slot) {
      if(slot.currentSlot) {
        return "currentSlot"
      }
    },
    refresh() {
      this.forceSpinner = true
      this.getTrackmanRefetch()
    },
    goDateToday() {
      this.$router.push('/trackman/' + this.selectedTrackman.selectedItem.id + '/' + dayjs.tz(new Date()).format('YYYY-MM-DD'))
      this.forceSpinner = true
      this.selectedDate = dayjs.tz(new Date()).format('YYYY-MM-DD')
    },
    goDateBack() {
      this.$router.push('/trackman/' + this.selectedTrackman.selectedItem.id + '/' + dayjs.tz(this.selectedDate).subtract(1, 'day').format('YYYY-MM-DD'))
      this.forceSpinner = true
      this.selectedDate = dayjs.tz(this.selectedDate).subtract(1, 'day').format('YYYY-MM-DD')
    },
    goDateForward() {
      this.$router.push('/trackman/' + this.selectedTrackman.selectedItem.id + '/' + dayjs.tz(this.selectedDate).add(1, 'day').format('YYYY-MM-DD'))
      this.forceSpinner = true
      this.selectedDate = dayjs.tz(this.selectedDate).add(1, 'day').format('YYYY-MM-DD')
    },
  },
});
</script>

<style scoped>
#container {
  text-align: center;
  
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  
  color: #8c8c8c;
  
  margin: 0;
}

#container a {
  text-decoration: none;
}

section {
  margin-top: 1em;
  margin-bottom: 2.5em;
}

section:not(.full-width),
.full-width > header {
  padding: 0 10px;
}

.itemFlight {
    --background-hover: unset;
}

ion-button {
  --padding-end: 0;
  --inner-padding-end: 0;
  margin-inline: 0px 15px;
}

</style>